import React, { Component } from 'react';
import { DiffResult } from '../Grid/DiffResult';
import queryString from 'query-string';

export class LoosersInPercent extends Component {
    constructor(props) {
        super(props);

        const parameters = queryString.parse(this.props.location.search);

        this.state = {
            showDetailedView: parameters.detailedView === '1' || parameters.detailedView === 'true',
            oldYear: null,
            newYear: null,
            annualDiffData: null
        };
    }

    componentDidMount() {
        this.getAnnualDiffDefinition();
        this.getAnnualDiffWinners();
    }

    async getAnnualDiffDefinition() {
        fetch('api/AnnualDiff/Definition')
            .then(response => { return response.json(); })
            .then(data => this.setState({
                oldYear: data.oldYear,
                newYear: data.newYear
            }));
    }

    async getAnnualDiffWinners() {
        fetch('api/Loosers/InPercent')
            .then(response => { return response.json(); })
            .then(data => this.setState({
                annualDiffData: data
            }));
    }

    render() {
        return (
            <div className="grid-wrapper compact">
                <DiffResult
                    rowData={this.state.annualDiffData}
                    oldYear={this.state.oldYear}
                    newYear={this.state.newYear}
                    showDetailedView={this.state.showDetailedView}
                    showPercent={true}
                    variantName="Variant" />
            </div>
        );
    }
}
